import gender from "./gender.json";
import transaction from "./transaction.json";

export default {
  gender,
  transaction,
};
